import * as React from "react"
import Menu from "@mui/material/Menu"
import { IconButton, Typography } from "@mui/material"
import MoreVertIcon from "@mui/icons-material/MoreVert"
// import PersonOutlineIcon from '@mui/icons-material/PersonOutline'

import { Box } from "@mui/system"

import useStyles from "./useStyles"
import { config } from "../utils/configMenuItem"
import { useDispatch, useSelector } from "react-redux"
import { updateSubscription } from "../../../../redux/actions/eventanilla"
import { ConfirmModal } from "../../../../components/Modals/eventanilla/ConfirmModal"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { getUserRoles } from "../../../../utils/validateToken"

export default function ModalMenuItem({ item }) {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <MoreVertIcon
        sx={{
          color: "#026873",
          "&:hover": {
            color: "#00FFAC",
          },
        }}
        onClick={handleClickMenu}
      />

      <Menu
        id="basic-menu"
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <FiltersList item={item} onClose={handleClose} />
      </Menu>
    </>
  )
}

function FiltersList({ item, onClose }) {
  const classes = useStyles()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [openModalConfirm, setopenModalConfirm] = useState(false)
  const [statusSelected, setstatusSelected] = useState(null)
  const user = useSelector((state) => state.user)

  const handleCloseModalConfirm = () => {
    setopenModalConfirm(false)
  }
  const handleopenModalConfirm = (code) => {
    setstatusSelected(code)
    setopenModalConfirm(true)
  }
  const handleChangeStatusCode = async () => {
    if (statusSelected) {
      await dispatch(
        updateSubscription({
          serviceStatus: statusSelected,
          communicationSubscriptionVEId: item.communicationSubscriptionVEId,
        }),
      )
      onClose()
    }
  }

  const isRoleOnlyRead = () => {
    const appRoles = getUserRoles(user.eAuthToken)
    if (appRoles && appRoles.length > 0) {
      return (
        appRoles.includes("CGI.Admin") ||
        appRoles.includes("CGI.LegalCommOperator")
      )
    }
    return false
  }

  return (
    <>
      <Box
        sx={{
          height: 220,
          width: 400,
        }}
        className={classes.boxStyle}
      >
        {config.map((button) => {
          return button.dependences.includes(item.subscriptionStatus) &&
            isRoleOnlyRead() ? (
            <IconButton
              key={button.code}
              sx={{ borderRadius: 0, width: "100%", cursor: "pointer" }}
              onClick={() => {
                handleopenModalConfirm(button.code)
              }}
            >
              <Box className={classes.boxTypography}>
                {button.icon}
                <Typography className={classes.typographyStyle}>
                  {button.title}
                </Typography>
              </Box>
            </IconButton>
          ) : button.code === "INFORMATION" ? (
            <IconButton
              key={button.code}
              sx={{ borderRadius: 0, width: "100%" }}
              onClick={() =>
                navigate(`/ME/eventanilla/${item.cuitDestinatario}`)
              }
            >
              <Box className={classes.boxTypography}>
                {button.icon}
                <Typography className={classes.typographyStyle}>
                  {button.title}
                </Typography>
              </Box>
            </IconButton>
          ) : (
            <IconButton
              key={button.code}
              disabled
              sx={{ borderRadius: 0, width: "100%" }}
            >
              <Box className={classes.boxTypography}>
                {button.icon}
                <Typography className={classes.typographyStyle}>
                  {button.title}
                </Typography>
              </Box>
            </IconButton>
          )
        })}
      </Box>
      <ConfirmModal
        openModal={openModalConfirm}
        handleClose={handleCloseModalConfirm}
        handleConfirmFunction={handleChangeStatusCode}
        cuit={item.cuitDestinatario}
      />
    </>
  )
}
